import { createBrowserRouter, RouteObject } from 'react-router-dom';
import React, { Component, Suspense } from 'react';
import Spinner from '@cloudscape-design/components/spinner';

import AppContainer from 'src/components/common/AppContainer/AppContainer';

import { ROUTES } from './routes';
import Landing from 'src/components/pages/LandingPage';

// Lazy-load heavy pages — keeps them out of the main bundle
const ControlHomePage = React.lazy(() =>
  import('src/components/pages/ControlHomePage').then((m) => ({ default: m.ControlHomePage }))
);
const SummaryPage = React.lazy(() =>
  import('src/components/pages/SummaryPage').then((m) => ({ default: m.SummaryPage }))
);
const HistoricalExecutionsPage = React.lazy(() =>
  import('src/components/pages/HistoricalExecutionsPage').then((m) => ({
    default: m.HistoricalExecutionsPage,
  }))
);
const ReportsPage = React.lazy(() =>
  import('src/components/pages/ReportsPage').then((m) => ({ default: m.ReportsPage }))
);

export class ChunkErrorBoundary extends Component<
  { children: React.ReactNode },
  { hasError: boolean }
> {
  state = { hasError: false };
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('Chunk load error:', error, info);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ textAlign: 'center', padding: '100px' }}>
          <p>Something went wrong loading this page.</p>
          <button onClick={() => window.location.reload()}>Refresh</button>
        </div>
      );
    }
    return this.props.children;
  }
}

const LazyRoute = ({ children }: { children: React.ReactNode }) => (
  <ChunkErrorBoundary>
    <Suspense
      fallback={
        <div style={{ display: 'flex', justifyContent: 'center', padding: '100px' }}>
          <Spinner size="large" />
        </div>
      }
    >
      {children}
    </Suspense>
  </ChunkErrorBoundary>
);

export const routeConfig = [
  {
    path: ROUTES.HOME,
    element: <AppContainer />,
    children: [
      {
        index: true,
        element: <Landing />,
      },
      {
        path: ROUTES.CONTROL.BASE,
        element: (
          <LazyRoute>
            <ControlHomePage />
          </LazyRoute>
        ),
      },
      {
        path: ROUTES.CONTROL.SUMMARY,
        element: (
          <LazyRoute>
            <SummaryPage />
          </LazyRoute>
        ),
      },
      {
        path: ROUTES.CONTROL.HISTORICAL,
        element: (
          <LazyRoute>
            <HistoricalExecutionsPage />
          </LazyRoute>
        ),
      },
      {
        path: ROUTES.REPORTS.DETAIL,
        element: (
          <LazyRoute>
            <ReportsPage />
          </LazyRoute>
        ),
      },
    ],
  },
];

export const router = createBrowserRouter(routeConfig as RouteObject[]);
